<template>
  <ya-site-resource-list resource="status" />
</template>

<script>
import YaSiteResourceList from './resourceList'

export default {
  name: 'YaSiteRoomStatusList',
  components: { YaSiteResourceList },
}
</script>
